import React from 'react';
import AIInlinePrompt, {
	type AIInlinePromptProps,
} from '@atlassian/jira-atlassian-intelligence/src/ui/index.tsx';
import { useNaturalLanguageToJql } from './use-natural-language-to-jql/index.tsx';

export type Props = Omit<AIInlinePromptProps<string>, 'analyticsSource' | 'onPrompt'>;

export default function NaturalLanguageToJQL({ children, ...props }: Props) {
	const onPrompt = useNaturalLanguageToJql();

	return (
		<AIInlinePrompt {...props} onPrompt={onPrompt}>
			{children}
		</AIInlinePrompt>
	);
}
